import React from "react";
import { Styles } from "./styles";
import Lesson from "./lesson/Lesson";
import Loader from "../../common/loader/Loader";
import { Swiper, SwiperSlide } from "swiper/react";
import { Mousewheel, Pagination } from "swiper";
import { useMediaQuery } from "../../../helpers/useMediaQuery";

const NextLessons = ({ lessons, isLoading, videoUrl, setVideoUrl }) => {
  const isTablet = useMediaQuery("(max-width: 992px)");

  return (
    <Styles>
      {isLoading ? (
        <Loader />
      ) : (
        <div className="next-lesson">
          <Swiper
            direction={isTablet ? "horizontal" : "vertical"}
            slidesPerView={3}
            mousewheel={true}
            pagination={true}
            modules={[Mousewheel, Pagination]}
            spaceBetween={10}
            id="swiper"
          >
            {lessons?.map((item, idx) => {
              return (
                <SwiperSlide>
                  <Lesson
                    key={idx}
                    lessonNum={++idx}
                    setVideoUrl={setVideoUrl}
                    selectedVideo={videoUrl}
                    videoUrl={item}
                  />
                </SwiperSlide>
              );
            })}
          </Swiper>
        </div>
      )}
    </Styles>
  );
};

export default NextLessons;
